import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Home from './views/Home';
import About from './views/About';
import Rooms from './views/Rooms';
import Chapter1 from './views/Chapter1';
import Chapter2 from './views/Chapter2';
import Chapter3 from './views/Chapter3';
import Chapter4 from './views/Chapter4';
import Combo from './views/Combo';
import Directions from './views/Directions';
import Groups from './views/Groups';
import History from './views/History';
import Press from './views/Press';
import Store from './views/Store';
import Contact from './views/Contact';
import Tickets from './views/Tickets';

import './App.css';

function App() {
    return (
        <Router>
            <Switch>
                <Route exact path="/" component={Home} />
                <Route exact path="/about" component={About} />
                <Route exact path="/rooms" component={Rooms} />
                <Route exact path="/chapter1" component={Chapter1} />
                <Route exact path="/chapter2" component={Chapter2} />
                <Route exact path="/chapter3" component={Chapter3} />
                <Route exact path="/chapter4" component={Chapter4} />
                <Route exact path="/combo" component={Combo} />
                <Route exact path="/directions" component={Directions} />
                <Route exact path="/groups" component={Groups} />
                <Route exact path="/history" component={History} />
                <Route exact path="/press" component={Press} />
                <Route exact path="/store" component={Store} />
                <Route exact path="/contact" component={Contact} />
                <Route exact path="/tickets" component={Tickets} />
                <Route
                    path="/onlinegame"
                    component={() => {
                        window.location.href = 'https://thebunkerexperienceonline.com';
                        return null;
                    }}
                />
            </Switch>
        </Router>
    );
}

export default App;
